import React from 'react';
import { Icon } from '@/components/shared/Icon';
import { Link } from '@/components/shared/Link';
import { ResourceLocation } from '@/generated/data.schemas';
import styles from './Welcome.module.scss';

interface WelcomeProps {
	backButtonRoute?: ResourceLocation;
	backButtonText?: string;
	backButtonAriaLabel?: string;
}

export const Welcome: React.FunctionComponent<WelcomeProps> = ({
	backButtonRoute,
	backButtonText,
	backButtonAriaLabel,
}) => {
	return (
		<Link className={styles.backButton} route={backButtonRoute} aria-label={backButtonAriaLabel}>
			<Icon name={'chevronDown'} size={'lg'} rotate={'90'} />
			<span className={styles.text}>{backButtonText}</span>
		</Link>
	);
};
